import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './AuthContext';
import Login from './Login';
import Videos from './Videos';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/videos" element={<Videos />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
